/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Cohort overview across ALL sequences in the job for the range.
 *
 * Cohort = enrollments **created** within the date range. Status
 * bucketing reuses the shared ``ANALYTICS_*`` constants
 * (``enrollment_repos``) so this third surface agrees with the
 * sequences list and the per-sequence Enrollments tab. Rates are
 * unique-recipient fractions of ``total`` in ``[0, 1]``.
 */
export interface JobSequenceAnalyticsOverview {
  /** @minimum 0 */
  total: number;
  /** @minimum 0 */
  in_progress: number;
  /** @minimum 0 */
  finished: number;
  /** @minimum 0 */
  opened: number;
  /** @minimum 0 */
  replied: number;
  /** @minimum 0 */
  clicked: number;
  /**
     * @minimum 0
     * @maximum 1
     */
  open_rate: number;
  /**
     * @minimum 0
     * @maximum 1
     */
  reply_rate: number;
  /**
     * @minimum 0
     * @maximum 1
     */
  click_rate: number;
}
